<template>
<div>
  <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 10rem"></div>


  
  <div class="bg-light">
    <div class="container-custom">
      <div  class="row py-5">
          <div class="col-lg-3 col-md-4 col-12 sticky-div mt-3" :style="isDesktop ? 'height: 95vh; top: 1rem' : ''">
            <div class="card shadow p-4 rounded" :class="isDesktop ? '' : (showFilters ? '' : 'd-none')">
              <filterHome :panelColor="color" botonTransparent="btn-light-primary" clase="form-control"></filterHome>
            </div>
          </div>
          <div class="col-lg-9 col-md-8 col-12">    
          <div class="d-flex flex-column flex-md-row">
            <div data-aos="fade-down">
              <h1 class="h2">{{ $t('agents.heading') }}</h1>
              
              <div>
                <p class="text-secondary mb-0">
                  {{ $t('agents.showingOf', { shown: item.length, total: item.length }) }}
                </p>
              </div>
            </div>
            
            <div class="btn-toolbar-actions ml-md-auto d-flex align-items-center gap-2 mt-3 mt-md-0">
              <div class="btn-group-toggle-group align-items-center bg-card rounded shadow-sm p-1 d-none d-lg-flex">
                  <button
                    :class="showButton == true ? 'btn-active-primary' : 'btn-inactive'"
                    @click="showButton = true"
                    class="btn-toggle btn btn-sm"
                    :title="$t('properties.gridView')"
                  >
                    <i class="fa-solid fa-grip-vertical"></i>
                  </button>
                  <button
                    :class="showButton != true ? 'btn-active-primary' : 'btn-inactive'"
                    @click="showButton = false"
                    class="btn-toggle btn btn-sm"
                    :title="$t('properties.listView')"
                  >
                    <i class="fa-solid fa-list"></i>
                  </button>
                </div>
                
                <button class="btn btn-light-primary mr-auto btn-pill d-lg-none" @click="showFilters = !showFilters">
                  <i class="fas fa-sliders mr-1"></i> {{ $t('common.filter') }}
                </button>
              </div>
            </div>
            <hr />
            
            <alertComponent
              v-if="item.length == 0 && !loadingData"
              
              iconColor="primary"
              :variant="1"
              :icon="true"
              iconClass="fa-solid fa-user-group"
              :title="$t('agents.notFoundTitle')"
              :description="$t('agents.notFoundDesc')"
            ></alertComponent>

            <div class="d-none d-sm-block" v-else>
              <div v-if="showButton == true" class="row ml-auto mr-auto">
                <div class="col-6 mx-0" v-for="(el, index) in item" :key="el.Id">
                  <CardAgent  :product="el" data-aos="fade-up" :data-aos-delay="index * 100" />
                </div>
              </div>    
              <div v-else class="">
                <div  class="row ml-auto mr-auto">
                  <div class="col-12 mx-0" v-for="(el, index) in item" :key="el.Id">
                    <CardAgentLarge  :detail="false"  class="bg-card rounded shadow"  :product="el" data-aos="fade-up" :data-aos-delay="index * 100" />
                  </div>
                </div> 
              </div>
              
            </div>
            <div class="d-md-none" v-if="item.length > 0">
                <div   class="row ml-auto mr-auto">
                  <div class="col-12 mx-0" v-for="(el, index) in item" :key="el.Id">
                    <CardAgent   :product="el" data-aos="fade-up" :data-aos-delay="index * 100" />
                  </div>
                </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from 'aos'

import ContactInfo from "../components/ContactInfo.vue";
import filterHome from "../components/filterHome.vue";
import CardAgent from "../components/CardAgent.vue";
import CardAgentLarge from "../components/CardAgentLarge.vue";
import CardImg from "../components/Card-img.vue";
import alertComponent from "../components/alertComponent.vue";
// import ProductDetailVue from "../components/ProductDetail.vue";
import contact from '../components/Contact.vue'
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";


export default {
  
  components: { CardAgent, CardImg, contact, CardAgentLarge, filterHome,  ContactInfo, alertComponent    },
  props: ["NavSolid" , ],
  data() { 
     
    return {
      color: false,
      table: 'Agente',
      item:[],
      loadingData: false,
      showButton: true,
      show: true,
      showFilters: false,
      isDesktop: true,
     

      
    };
  },
  async mounted() {
    this.checkDesktop();
    window.addEventListener('resize', this.checkDesktop);
    
    this.loadingData = true;
    this.$isLoading(true)
    await this.getData()
    this.$isLoading(false)
    this.loadingData = false;

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDesktop);
  },
  updated() {
    AOS.refresh()
  },
  methods: {
    checkDesktop() {
      this.isDesktop = window.innerWidth >= 992;
      if (this.isDesktop) this.showFilters = true;
    },
    async getData() {
      try {
        this.loadingData = true;
        const domain = encodeURIComponent(resolveStoredPublicDomain(this.$domain));
        let res = await this.$store.dispatch("get", { path: this.table + `/public/getByTenantId/?domain=${domain}` });
          console.log('resss --->', res)
        
        if(res.length>0){
          
          // Filtrar agentes que no son administradores
          this.item = res.filter(agent => !agent.IsSuperAdmin && agent.IsPublic !== 1);
          console.log('ln-134 --->',this.item)
        }
        else{
          this.item = []
        }
      } catch (error) {
        this.item = []
        alert(error);
      } finally {
        this.loadingData = false;
      }
    },

    ///////////////
     
     
     
    // showProductDetail(item) {
    //   item["quantity"] = 1;
    //   this.productData = item;
    //   this.$bvModal.show("modal-productDetail");
    // },
     
      
  },
};
</script>
<style scoped>
.footer-section .map-container iframe {
  border-radius: 5px;
}
 .tab-menu {
            display: flex;
            padding: 0;
            margin: 0;
            list-style-type: none;
            background-color: var(--bg-card);
            border-bottom: 1px solid #ddd;
        }
        .tab-menu li {
            margin-right: 20px;
            padding: 10px 15px;
            cursor: pointer;
            color: #555;
            font-weight: bold;
        }
        .tab-menu li.active {
            color: var(--primary);
            border-bottom: 2px solid var(--primary);
        }
       
        
        .details {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
        }
        .details div {
            width: 45%;
            margin-bottom: 10px;
            font-size: 14px;
            color: #555;
        }
        .details div strong {
            color: #333;
        }
        .property-brief {
            margin-top: 20px;
            color: #555;
            font-size: 14px;
            line-height: 1.6;
        }
        .attachments {
            margin-top: 20px;
            font-size: 14px;
        }
        .attachments a {
            text-decoration: none;
            color: var(--primary);
            font-weight: bold;
        }
        .attachments i {
            margin-right: 5px;
        }
        .map-link {
            float: right;
            color: var(--primary);
            font-size: 14px;
            cursor: pointer;
            text-decoration: none;
        }
.containerV {
  display: flex;
  flex-direction: column; /* Organiza en columna */
  justify-content: center; /* Centra verticalmente */
  align-items: center; /* Centra horizontalmente */
  /*gap: 10px; /* Espacio entre el texto y los botones */
    /* Altura total */
  /* border: 1px solid #ddd; */
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fdfcfc; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #e9e9e9; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e9e9e9; 
}
.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  
  scroll-snap-type: mandatory;
  scroll-behavior: smooth;
  
  word-wrap: break-word !important; 
  margin-bottom: 50px;
}

.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;
  
  /* white-space: nowrap; */
}
/*Slider X (different sized images)*/

.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}

.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}

.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}

.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}
 
.searchdiv {
  /* background-color:#fd306e !important; */
  /* background-color: black !important; */
  /* padding: 30px;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px; */
}
.buttonsearch {
  background-color: #fd306e !important;
  color: white;
}
.inputSearch {
  border-color: #fd306e !important;
}

.carousel-item img {
  /* height:100vh!important ; */
}

@media (max-width: 991px) {
  .sticky-div {
    position: relative !important;
    height: auto !important;
    max-height: none !important;
  }
}

@media (max-width: 767px) {
  .btn-toolbar-actions {
    flex-wrap: nowrap;
    gap: 0.4rem !important;
    margin-top: 1rem;
    width: 100%;
    justify-content: flex-end;
  }
  
  .btn-toggle {
    padding: 0.4rem 0.6rem;
    font-size: 0.875rem;
    min-width: 36px;
    min-height: 36px;
  }
  
  .btn-group-toggle-group {
    gap: 0.25rem;
  }
  
  .btn-toolbar-actions > div {
    flex-shrink: 0;
  }
}

@media (max-width: 576px) {
  .btn-toolbar-actions {
    gap: 0.3rem !important;
  }
  
  .btn-toggle {
    padding: 0.35rem 0.5rem;
    font-size: 0.8rem;
    min-width: 32px;
    min-height: 32px;
  }
}

</style>
